export default "__VITE_ASSET__Day6J6XC__"